import './index.css';

import React, {Component} from 'react';

export default class HelloWorld extends Component {
  render() {
    return (
      <div className="HelloWorld">Component says Hello</div>
    );
  }
}


/** WEBPACK FOOTER **
 ** ../~/eslint-loader!../src/HelloWorld/index.js
 **/